import Api from '@/services/Index';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/daily/course/schedules/meb-ylsy-instructor-course-load', config);
}
const exportExcel = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    config.responseType = 'blob'
    return Api.get('/daily/course/schedules/meb-ylsy-instructor-course-load-report', config);
}
const importExcel = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/daily/course/schedules/meb-ylsy-instructor-course-load-import', config);
}


export default {
    getAll,
    exportExcel,
    importExcel
}
